export const TranslationsES = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "Pedir",
        cart: "Cesta",
        open_24: "24 Horas",
        closed: "Cerrado",
        free: "GRATIS",
        something_went_wrong: "Algo salió mal",
        try_again: "Inténtalo de nuevo",
    },
    constants: {
        calendar: {
            days: {
                monday: "Lunes",
                tuesday: "Martes",
                wednesday: "Miércoles",
                thursday: "Jueves",
                friday: "Viernes",
                saturday: "Sábado",
                sunday: "Domingo",
            },
        },
        services: {
            pickup: "Recoger en Tienda",
            delivery: "Entrega a Domicilio",
            dine_in: "Pedido en Sala",
            table_booking: "Reservar",
        },
        payment: {
            method: {
                cash: "Efectivo",
                card: "Tarjeta",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "CardConnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Personalizado",
            },
            backend_method: {
                cash: "Efectivo",
                card: "Tarjeta",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "CardConnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Personalizado",
            },
            status: {
                success: "Completado",
                pending: "Pendiente",
                error: "Error",
                refunded: "Reintegrado",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "Eliminar",
                drop_here: "Arrastra tus archivos aquí o haz clic para seleccionar uno",
                accepts: "Accepts {{fileTypes}} files",
                errors: {
                    max_files: "Máximo de {{number}} permitidos",
                    max_size: "Máximo tamaño de fichero de {{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'La tienda está actualmente cerrada y no se puede realizar un pedido para cenar en la sala. Puede intentar pedir en una fecha y hora posteriores',
            },
            buttons: {
                order: {
                    book_order: 'Reservar / Pedir',
                    order_online: 'Pedir',
                    book_table: 'Reservar',
                    order: 'Pedido',
                    book: 'Reservar',
                    cart: 'Cesta',
                    restart: 'Reiniciar',
                    closed: 'Tienda Cerrada',
                    not_accepting: 'No Aceptamos Pedidos',
                },
            },
        },
        modals: {
            auth: {
                login: 'Login',
                register: 'Registrarse',
                register_commence: 'Continuar',
                register_complete: 'Crear Cuenta',
                register_confirmation_sent: 'Se ha enviado un código de confirmación a su dirección de correo electrónico. Por favor, introdúzcalo a continuación para continuar',
                register_confirmation_resent: 'El código de confirmación ha sido enviado nuevamente, verifique su correo no deseado o reinicie el proceso',
                register_restart: 'Reiniciar',
                register_resend_code: 'Reenviar código',
                register_confirmation_code_subject: 'Código de confirmación de correo electrónico',
                register_confirmation_code_email: 'Su código de confirmación por correo electrónico es {{confirmation_code}} (Caduca en 24 horas)',
                login_placeholder: 'Correo electrónico',
                password_placeholder: 'Contraseña',
                confirm_password_placeholder: 'Confirmar contraseña',
                confirmation_code_placeholder: 'Código de confirmación de email',
                accept_terms: 'Aceptar los términos y condiciones',
                accept_terms_view: 'Ver',
                login_facebook: 'Login con Facebook',
                login_google: 'Login con Google',
                benefits: 'Inicie sesión o cree una cuenta para guardar todos sus pedidos',
                logged_in: 'Sesión iniciada exitosamente',
                logged_out: 'Desconectado',
                password_reset: {
                    init_button: 'Enviar contraseña Restablecer correo',
                    init_success: 'Se ha enviado el enlace de restablecimiento de contraseña a su correo electrónico',
                    complete_button: 'Restablecer la contraseña',
                    complete_success: 'La contraseña se restableció correctamente, inicie sesión con su nueva contraseña',
                    forgot_password_text: '¿Olvidaste tu contraseña?',
                    forgot_password_link: 'Restablecer la contraseña',
                    remember_password_text: '¿Recuerdas tu contraseña?',
                    remember_password_link: 'Regresa',
                    invalid_title: 'Restablecimiento de contraseña no válido',
                    invalid_description: 'Este enlace de restablecimiento de contraseña no es válido, solicite uno nuevo',
                    invalid_link: 'Ir al inicio de sesión',
                    title: 'Restablecimiento de contraseña',
                    description: 'Introduzca una nueva contraseña para su cuenta',
                },
                error_generic: 'Algo salió mal, por favor intente nuevamente o contáctenos',
                error_accept_terms: 'Por favor acepte los términos y condiciones',
                error_password_length: 'Mínimo de 6 caracteres para contraseña',
                error_social: 'Algo salió mal, intente nuevamente o contáctenos',
                error_confirmation_code: 'Código de confirmación inválido',
                error_invalid_code: 'Código de confirmación inválido',
                error_exists: 'El usuario ya existe',
                error_invalid_email_pass: 'Dirección de correo electrónico o contraseña no válidos',
                error_password_no_match: 'Las contraseñas no coinciden',
                error_user_not_found: 'Ningún usuario con esa dirección de correo electrónico',
                error_invalid_email: 'Dirección de correo electrónico no válida',
                error_invalid_reset_token: 'Enlace de reinicio no válido, solicite otro',
            },
            booking: {
                form: {
                    name: 'Nombre Completo',
                    email: 'Dirección de Correo Electrónico',
                    phone: 'Número de Teléfono',
                    number_of_people: 'Número de Personas',
                    number_of_people_max: 'Número de Personas ({{max_people}} Máx)',
                    number_of_people_min: 'Número de Personas ({{min_people}} Mín)',
                    number_of_people_max_min: 'Número de Personas (de {{min_people}} a {{max_people}})',
                    notes: 'Notas / Solicitudes Especiales',
                    submit: 'Enviar Solicitud de Reserva',
                    email_optional: '(opcional)',
                    date: 'Fecha',
                    duration: 'Duración',
                    seating: 'Horarios disponibles',
                    number_of_guests: 'Número de comensales',
                    notes_placeholder: 'Alergias, ocasión, preferencia de asiento',
                    reserving: 'Reservando...',
                    reserve_table: 'Reservar mesa',
                    please_choose_a_date_and_time: 'Por favor, elige una fecha y una hora.',
                    invalid_people: 'El número de comensales debe estar entre {{min}} y {{max}}.',
                    party_size_max_fallback: 'el máximo permitido',
                    loading_available_times: 'Cargando horarios disponibles…',
                    select_a_date_to_see_available_times: 'Selecciona una fecha para ver los horarios disponibles.',
                    no_times_available_for_this_date: 'No hay horarios disponibles para esta fecha. Por favor, elige otro día.',
                    shift: 'Turno',
                    service_times: 'Horarios de servicio',
                    new_shift: 'Nuevo turno',
                    time: 'horario',
                    times: 'horarios',
                    unavailable: 'No disponible',
                    available: 'Disponible',
                    required_name: 'Por favor, introduce tu nombre.',
                    required_phone: 'Por favor, introduce tu número de teléfono.',
                    required_email: 'Por favor, introduce tu correo electrónico.',
                    invalid_email: 'Por favor, introduce un correo electrónico válido.',
                    required_terms: 'Por favor, acepta los términos antes de reservar.',
                    missing_custom_fields: 'Por favor, completa todas las preguntas obligatorias.',
                    reservation_is_unavailable: 'La reserva no está disponible.',
                    please_contact_the_restaurant_directly: 'Por favor, contacta directamente con el restaurante.',
                    almost_done: 'Casi listo',
                    your_details: 'Tus datos',
                    tell_us_who_s_coming: 'Dinos quién viene para que podamos confirmar tu reserva.',
                    book_your_table: 'Reserva tu mesa',
                    choose_a_time_that_works_for_you: 'Elige un horario que te convenga.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Envía tu solicitud de reserva y el restaurante se encarga del resto.',
                    select_date: 'Seleccionar fecha',
                    standard: 'Estándar',
                    minutes: 'minutos',
                    next: 'Siguiente →',
                    back: '← Atrás',
                    accept_terms: 'Acepto los términos y condiciones.',
                    info_1: 'Recibirá una notificación por correo electrónico cuando su reserva sea aceptada o denegada',
                },
                errors: {
                    not_found: 'La reserva no existe. Posiblemente fue eliminado',
                    booking_not_found: 'La reserva no existe. Es posible que haya sido eliminada',
                    generic: 'Algo salió mal, actualiza la página o contáctanos',
                    something_went_wrong: 'Algo salió mal',
                    accept_terms: 'Por favor acepte los términos y condiciones',
                    required_phone: 'Por favor, introduzca su número de teléfono',
                    required_email: 'Por favor, introduzca su correo electrónico',
                    required_name: 'por favor, escriba su nombre',
                    invalid_email: 'Por favor, introduce una dirección de correo electrónico válida',
                    invalid_phone: 'Por favor, introduzca un número de teléfono válido',
                    invalid_people: 'Número inválido de personas',
                    booking_capacity_threshold: 'Estamos completos para este horario. Por favor, prueba otro horario.',
                    slot_unavailable: 'Estamos completos para este número de comensales. Por favor, prueba otro horario.',
                    booking_date_paused: 'Las reservas están pausadas para esta fecha. Por favor, elige otro día.',
                    invalid_table_assignment: 'Esas mesas no pueden acomodar a tu grupo. Por favor, elige otro horario.',
                    exceeded_order_limit: 'Demasiadas solicitudes de reserva. Por favor, inténtalo de nuevo más tarde.',
                    validation_failed_recaptcha_v3: 'Se ha detectado tráfico inusual. ¿Estás usando una VPN? Completa el desafío de arriba e inténtalo de nuevo.',
                    validation_failed_recaptcha_v2: 'No pudimos iniciar la reserva. Por favor, inténtalo de nuevo o usa otro método. Si usas una VPN, prueba a desactivarla primero.',
                    booking_already_exists: 'Esta reserva ya fue enviada. Revisa tu correo o abre tu enlace de reserva.',
                    invalid_party_size: 'Por favor, elige un número de comensales válido.',
                    invalid_request: 'Solicitud no válida. Por favor, actualiza la página e inténtalo de nuevo.',
                    table_booking_unavailable: 'La reserva de mesa no está disponible.',
                },
            },
            cart: {
                title: 'Cesta',
                proceed_to_checkout: 'Finalizar',
                edit_dish: 'Editar',
                remove_dish: 'Eliminar',
                no_items_1: 'No hay artículos en la cesta.',
                no_items_2: 'Agregue algún producto antes para continuar',
                free_delivery_notice: 'Entrega gratuita para pedidos por encima de {{value, currency}}',
                errors: {
                    min_order_promo: 'Mínimo pedido por valor de {{value, currency}} requerido para poder aplicar esta promoción',
                    min_order_delivery: 'Mínimo pedido por valor de {{value, currency}} para entregar a domicilio',
                },
                promo: {
                    heading: 'Código Promocional',
                    placeholder: 'Introduce tu código de promoción',
                    add: 'Agregar Código',
                    title: 'Promo {{name}} agregada a la cesta',
                    fixed_discount: '{{value, currency}} Off',
                    percent_discount: '{{value}}% Off',
                    added_to_cart: 'Promo agregada a la cesta',
                    errors: {
                        not_found: 'Promo no encontrada',
                        disabled: 'La promoción está deshabilitada',
                        not_available: 'La promoción no está disponible actualmente',
                        logged_in_only: 'Debe iniciar sesión para usar esta promoción',
                        already_used: 'Ya has usado esta promoción',
                        invalid: 'Esta promoción ya no es válida',
                        invalid_service: 'Esta promoción no es válida para el servicio elegido',
                        later_only: 'Válido solo para pedidos por adelantado',
                        now_only: 'Válido solo para pedidos con vencimiento inmediato, no pedidos por adelantado',
                        generic: 'Vaya ... algo salió mal y ha iniciado sesión',
                        dishes_required_multi: 'Esta promoción solo se aplicará cuando se agreguen ciertos platos a su cesta',
                        dishes_required_single: "Esta promoción será áplicada únicamente para '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Propina',
                    placeholder: 'Dar Propina',
                },
            },
            checkout: {
                title: 'Resumen',
                subtitle: 'Confirme los detalles de su pedido',
                details: {
                    service: 'Servicio',
                    due: 'Entrega',
                    due_now_asap: 'Ahora / Lo antes posible',
                    address: 'Dirección de Entrega',
                    total: 'Total',
                    table: 'Mesa',
                    store_location: 'Dirección de la Tienda',
                },
                customer: {
                    title: 'Cliente',
                    subtitle: 'Inicie sesión para guardar su pedido y detalles',
                    button: 'Login',
                    name: 'Nombre Completo',
                    email: 'Correo Electrónico',
                    phone: 'Número de Teléfono',
                    phone_important: 'Número de Teléfono (Importante)',
                    notes: 'Observaciones',
                    delivery_notes: 'Instrucciones de Entrega / Notas del Pedido',
                    optional: 'Opcional',
                },
                payment: {
                    title: 'Método de Pago',
                },
                accept_terms: 'Aceptar Términos y Condiciones',
                accept_terms_view: 'Ver',
                processing_order: 'Procesando Pedido',
                warning: {
                    different_payment_currency: 'Precios de la tienda en {{store_currency}} pero método de pago en {{payment_currency}}',
                    closing_soon: 'Cerraremos pronto, los pedidos han de ser realizados en {{value}} minutos',
                    closed: 'Lo sentimos, este servicio se ha cerrado y no se aceptan pedidos',
                    expired: 'Ya no podemos servir su pedido en el momento seleccionado. Por favor, elija una fecha u hora posterior',
                },
                errors: {
                    stripe_generic: 'Error de tarjeta de crédito, inténtelo nuevamente o elija otro método',
                    validation_failed: 'No se puede aceptar este pago en este momento. Inténtelo nuevamente más tarde o elija otro método de pago.',
                    stripe_loading_fail: 'Se produjo un error al cargar el formulario de pago. Vuelve a intentarlo',
                    something_went_wrong: 'Algo salió mal',
                    paypal_generic: 'Algo salió mal con PayPal, inténtelo nuevamente o elija otro método de pago',
                    payment_fail: 'Pago fallido, inténtelo nuevamente o seleccione otro método de pago',
                    payment_cancelled: 'Pago cancelado, inténtelo nuevamente o seleccione otro método de pago',
                    payment_error: 'Error al procesar el pago, inténtelo nuevamente o elija otro método de pago',
                    payment_declined: 'Su método de pago fue rechazado',
                    card_declined: 'Se rechazó su tarjeta y no se pudo procesar el pago',
                    promo_max_uses_exceeded: "Este código promocional ha alcanzado su límite de uso y ya no está disponible.",
                    store_closed: 'La tienda está cerrada y ya no acepta pedidos',
                    accept_terms: 'Por favor acepte los términos y condiciones',
                    required_payment: 'Por favor seleccione un método de pago',
                    required_phone: 'Por favor, introduzca su número de teléfono',
                    required_email: 'Por favor introduzca su correo electrónico',
                    required_name: 'por favor, escriba su nombre',
                    invalid_email: 'Por favor, introduce una dirección de correo electrónico válida',
                    invalid_phone: 'Por favor ingrese un número de teléfono válido',
                    invalid_cc_number: 'Su número de tarjeta de crédito no es válido',
                    invalid_order_amount: 'Cantidad mínima requerida para este método de pago',
                    retry_cc_number: 'Algo salió mal, vuelva a ingresar su número de tarjeta de crédito e inténtelo nuevamente',
                    closed: 'La tienda está cerrada / cerrada y no acepta pedidos',
                    promo_login_required: 'Debe iniciar sesión para usar esta promoción',
                    promo_used: 'Ya has usado esta promoción',
                    promo_by_payment_method_not_applicable: 'La promoción no es aplicable al método de pago seleccionado',
                    exceeded_order_limit: 'Estamos recibiendo muchos pedidos en este momento. Por favor, elija un horario más tarde.',
                    exceeded_order_limit_later: 'Ya no podemos cumplir con su pedido en el horario seleccionado. Por favor, elija una fecha u hora posterior.',
                },
                button: {
                    continue: 'Continuar y Pagar',
                    place_order: 'Realizar Pedido',
                },
            },
            customer: {
                age_v: {
                    title: 'Verificación de edad',
                    required_for_items: 'Requerido para pedir ciertos artículos',
                    min_age: 'Edad mínima: {{age}} años',
                    est_time: 'Tiempo de verificación estimado: {{time}} horas',
                    upload_description: 'Cargue su ID a continuación para su verificación. Se le notificará por correo electrónico una vez verificado. Cargue hasta 2 imágenes con un tamaño máximo de 2 MB cada una',
                    pending_description_1: 'Gracias por enviar sus documentos. Se le notificará por correo electrónico cuando sea aprobado',
                    pending_description_2: 'Refresca la página para actualizar el status de tu verificación. El tiempo de verificación estimado es {{time}} horas',
                    approved_description: 'Su cuenta ha sido verificada y puede pedir desde menús restringidos',
                    rejected_description: 'Su identificación ha sido rechazada. Si desea volver a intentarlo, vuelva a cargar su ID',
                    upload: 'Subir',
                    reupload: 'Volver a cargar documentos',
                    go_back: 'Regresa',
                    view_document: 'Ver Documento {{number}}',
                    status: {
                        unverified: 'No Verificado',
                        pending: 'A la espera de la aprobación',
                        approved: 'Aprobado',
                        rejected: 'Rechazado',
                    },
                },
                headings: {
                    sessions: 'Sesiones',
                    orders: 'Pedido',
                    spend: 'Gastar',
                    order_history: 'Historial de Pedidos',
                    loyalty_points: 'Puntos de lealtad',
                },
            },
            custom_payment: {
                title: '{{name}} Formulario de Pago',
                description: 'Has llegado a nuestro formulario de pago. Completa los campos a continuación para realizar un pago. Si no se ingresa una cantidad, sus datos se guardarán pero no se le cobrará.',
                disabled: 'Esta página de pago no se ha configurado correctamente. Ponte en contacto con el propietario del sitio para solucionar el problema.',
                success: 'Tu pago se procesó correctamente y tus datos se guardaron. Gracias',
                back: 'De Vuelta a Casa',
                fields: {
                    name: 'Nombre Completo',
                    email: 'Correo Electrónico',
                    reference: 'Referencia del Pago',
                    amount: 'Cantidad (€)',
                    name_on_card: 'Nombre en la Tarjeta',
                    submit: 'Realizar Pago',
                },
                warning: {
                    currency: 'Nota: Cantidad del pago en {{actual}}, no {{default}}',
                },
                errors: {
                    generic: 'Algo salió mal, inténtelo nuevamente o contáctenos',
                    stripe_generic: 'Error de tarjeta de crédito, actualice la página e inténtelo nuevamente',
                    payment_fail: 'Pago fallido, inténtelo nuevamente o seleccione otro método de pago',
                    payment_cancelled: 'Pago cancelado, inténtelo nuevamente o seleccione otro método de pago',
                    payment_error: 'Error al procesar el pago en línea, inténtelo nuevamente o elija otro método de pago',
                    payment_declined: 'Su método de pago fue rechazado',
                    card_declined: 'Se rechazó su tarjeta y no se pudo procesar el pago.',
                    promo_max_uses_exceeded: "Este código promocional ha alcanzado su límite de uso y ya no está disponible.",
                },
            },
            dish: {
                add: 'Añadir a la cesta',
                edit: 'Actualizar elemento',
                notes: 'Instrucciones especiales...',
                ingredients: {
                    title: 'Ingredientes',
                    uncheck_remove: 'Desmarque para eliminar',
                },
                ingredients_title: 'Ingredientes',
                combo: {
                    choose_dish: 'Elige un plato',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Seleccione uno (Obligatorio)',
                        select_one_optional: 'Seleccione uno (Opcional)',
                        select_between: 'Seleccione entre {{min}} - {{max}} (Obligatorio)',
                        select_at_least: 'Seleccione al menos {{qty}} (Obligatorio)',
                        select_up_to: 'Seleccione hasta {{qty}} (Opcional)',
                        select_multiple: 'Múltiple Selección (Opcional)',
                        free_amount: 'Primeros {{qty}} Gratis / {{selected}} Seleccionados',
                    },
                },
                error: 'Corrija las opciones marcadas en rojo.',
                added_to_cart: 'Artículo agregado a la cesta',
            },
            map: {
                zone_fee: 'Gastos de envío',
                view_in_google: 'Ver en Google Maps',
            },
            portal_go_back: {
                title: '¿Volver a la búsqueda de restaurantes?',
                description: 'Cualquier artículo en su cesta se perderá',
                cancel: 'Cancelar',
                proceed: 'Ir Atrás',
            },
            order: {
                config: {
                    services: {
                        title: 'Elige un Servicio',
                        table_booking: 'Reserva',
                    },
                    address_custom: {
                        input_placeholder: 'Introduzca su dirección',
                    },
                    address: {
                        input_placeholder: 'Busca tu dirección de entrega',
                        extras_placeholder: 'Opcional: Piso y letra, nombre de edificio, etc.',
                        search_placeholder: 'Busca tu dirección',
                        search_input_placeholder: 'Ingrese dirección a buscar',
                        no_address_found: 'No se encontraron direcciones',
                        not_found: 'Dirección de entrega no encontrada o válida, inténtalo nuevamente',
                        not_delivering: 'Actualmente no estamos entregando en esta dirección',
                        not_in_range: 'Tu dirección no está dentro del alcance de nuestra tienda',
                        not_in_zone: 'Tu dirección no está dentro de una zona de entrega activa',
                        location_permission: '¿Permitir que este sitio web acceda a su ubicación actual?',
                        location_permission_warning: 'No se puede acceder a su ubicación actual. Habilite el servicio de ubicación en su dispositivo y navegador web. Aquí tienes algunas referencias:',
                        pick_location: 'Elija su ubicación',
                        pick_location_help_text: 'Arrastre el marcador para elegir la ubicación en el mapa.',
                        use_current_location: 'Usar ubicación actual',
                        locate_on_map: 'Localizar en el mapa',
                    },
                    datetime: {
                        title: '¿Para cuándo es tu pedido?',
                        due_now: 'Ahora',
                        due_later: 'Más Tarde',
                        service_not_available: 'Lo sentimos, en este momento no estamos aceptando pedidos para {{service}}',
                        currently_closed: '{{service}} actualmente no disponible, pero puedes programar tu pedido ahora para más tarde',
                        due_unavailable: 'No disponible',
                        due_closed: 'Cerrado',
                        select_date: 'Seleccionar Fecha',
                        select_time: 'Seleccionar Hora',
                        select_order_date: 'Selecciona la Fecha de tu Pedido',
                        select_order_time: 'Selecciona la Hora de tu Pedido',
                        select_order_date_time: 'Selecciona la fecha/hora de tu pedido',
                        select_booking_date: 'Selecciona la Fecha de tu reserva',
                        select_booking_time: 'Selecciona la Hora de tu reserva',
                        no_times_available: 'No hay horarios disponibles para elegir',
                        date_today: '(Hoy)',
                        date_closed: '(Cerrado)',
                        date_bookings_paused: '(Reservas pausadas)',
                        time_slot_closed: 'Cerrado',
                    },
                    number_of_people: {
                        placeholder: 'Número de personas',
                    },
                    table: {
                        select: 'Selecciona Tu Mesa',
                        select_popup_title: 'Selecciona Tu Mesa',
                        password: 'Contraseña',
                        password_warning: 'Introduzca la contraseña de su mesa para continuar',
                    },
                    warning: {
                        closed: 'Lo sentimos, actualmente estamos cerrados / no aceptamos ningún pedido',
                        not_available: 'Lo sentimos, actualmente no estamos aceptando ningún pedido',
                    },
                    eta: {
                        delivery: `El tiempo estimado de entrega es de aproximadamente {{minutesToCustomer}} minutos`,
                        pickup: `El pedido estará listo en aproximadamente {{minutesToCustomer}} minutos`,
                    },
                    start_button: 'Pedir',
                },
                history: {
                    invalid: 'No seleccionable para volver a realizar pedido ya que algunos de los artículos pedidos han sido modificados o ya no están disponibles',
                },
                reorder: {
                    title: 'Repetición de Pedido Rápida',
                    description: 'Pida fácilmente los artículos de sus pedidos anteriores',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Pedido no encontrado, actualice la página e inténtelo nuevamente',
                    generic: 'Algo salió mal, actualice la página o contáctenos',
                },
                connection: {
                    connected: 'Actualizaciones en tiempo real',
                    connecting: 'Actualizaciones en tiempo real conectando',
                    disconnected: 'Actualizaciones en tiempo real desconectadas',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Advertencia',
                    title: 'Cerrar Sesión',
                    body: 'Cerrar la sesión eliminará todos los artículos que se hayan agregado a su cesta',
                    cancel: 'Cancelar',
                    proceed: 'Continuar',
                },
                order_restart: {
                    warning: 'Advertencia',
                    title: 'Cambiar detalles del pedido',
                    body: 'Cambiar los detalles de su pedido eliminará los artículos en su cesta ya que ciertos platos pueden no estar disponibles',
                    cancel: 'Cancelar',
                    proceed: 'Continuar',
                },
                order_expired: {
                    subtitle: 'Importante',
                    title: 'Pedido procesado para ser atendido de inmediato / lo antes posible',
                    description: 'La hora seleccionada para su pedido está cerca. Por ello, su pedido se está gestionando para ser atendido de inmediato / lo antes posible',
                    button: 'Ok',
                },
                order_expiring: {
                    subtitle: 'Importante',
                    title: 'Fecha Límite de Pedido Venciendo en Breve',
                    description: 'Tu pedido debe ser generado antes de {{time, timeFromTimestamp}} en caso contrario, ya no será válido',
                    button: 'Ok',
                },
                location_permission: {
                    cancel: 'Cancelar',
                    proceed: 'Continuar',
                },
            },
            card_payment_authentication: {
                title: 'Autenticación de Pago',
                note: 'Por favor, mantenga esta ventana abierta hasta que complete el proceso de autenticación de su banco.',
            },
            maps: {
                cancel: 'Cancelar',
                use_location: 'Usar ubicación',
            },
        },
        sections: {
            nav_top: {
                guest: "Invitado",
                login: "Login",
                login_signup: "Login / Registrarse",
                logout: "Cerrar Sesión",
            },
            menus: {
                info: {
                    no_menus: "Actualmente no hay menús disponibles",
                    restrictions: "Condiciones del Menú",
                    not_available: "Menú Actualmente no Disponible",
                    unavailable: {
                        times: "Menú no disponible, su pedido no cumple con las condiciones del menú",
                        services: "Menú no disponible, su pedido no cumple con las condiciones del menú",
                        hours: "Menú no disponible, su hora de pedido no está dentro de las horas disponibles del menú",
                        pre_order: "Menú no disponible, su pedido no cumple con las condiciones de pedido anticipado",
                        age: "Menú no disponible, debe iniciar sesión con una cuenta de edad verificada para pedir desde este menú",
                    },
                    services: {
                        title: "Requisitos del Pedido",
                        pickup: "Recoger en Tienda",
                        delivery: "Entrega a Domicilio",
                        dine_in: "Pedido en Sala",
                    },
                    times: {
                        now: "No Pedidos Anticipados",
                        later: "Sólo Pedidos Anticipados",
                    },
                    hours: {
                        title: "Horas Disponibles",
                    },
                    preorder: {
                        title: "Requisitos de Pedido Anticipado",
                        days_in_advance: "Debe pedir {{days}} días antes",
                        cutoff_time: "Hora límite del último día a las {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Restricción de Edad",
                        approved: "Su cuenta está verificada y puede pedir desde este menú",
                        rejected: "Requiere verificación de edad para pedir. Crea una cuenta y sube tu ID",
                    },
                },
                search: {
                    title: 'Buscar Platos',
                    no_result: 'No hay resultados para su consulta de búsqueda. Por favor inténtelo con otras palabras.',
                    placeholder: '¿Qué estás buscando?'
                }
            },
            info: {
                location: {
                    title: "Ubicación",
                    view_map: "Ver el Mapa",
                    phone: "Teléfono",
                },
                hours: {
                    title: "Horario de Apertura",
                    title_special: "Horario Especial de Apertura",
                },
                services: {
                    title: "Servicios",
                    notes: "Notas",
                    delivery: {
                        ranges: "Rangos de Entrega",
                        zones: "Zonas de Entrega",
                        view_zones: "Ver Zonas en el Mapa",
                        fee: "Gastos de Envío",
                        fee_short: 'Tarifa',
                        fee_varies: "Varía, se muestra en la cesta",
                        min_order: "Pedido mínimo",
                        min_order_short: 'Ped. mín.',
                        no_min_order: "Sin pedido mínimo",
                        free_amount: "Cantidad de Entrega Gratuita",
                    },
                },
            },
            contact: {
                title: "Contáctenos",
                name: "Nombre",
                email: "Correo Electrónico",
                phone: "Teléfono",
                message: "Introduzca su mensaje...",
                send: "Enviar Mensaje",
                success: "Su mensaje ha sido enviado con éxito",
                error: "Algo salió mal, inténtalo de nuevo o más tarde",
            },
            footer: {
                powered_by: "Powered by",
                terms_and_conditions: "Términos y Condiciones",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Recibo de Reserva',
            details: {
                datetime: 'Reserva para',
                number_of_people: 'No. de personas',
                placed: 'Emitida',
                updated: 'Última Actualización',
                notes: 'Notas',
                name: 'Nombre',
                email: 'Correo electrónico',
                phone: 'Teléfono',
                store_address: 'Dirección de la Tienda',
            },
            status_update: {
                title: 'Reserva {{number}} Actualizada',
                body: 'El status de tu reserva ha sido actualizada a {{status}}',
            },
            email_common: {
                name: 'Nombre: {{name}}',
                phone: 'Teléfono: {{number}}',
                number_of_people: 'No. de personas: {{number}}',
                date: 'Fecha: {{date}}',
                time: 'Hora: {{time}}',
                location: 'Localización: {{name}}',
                notes: 'Notas: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Nueva Solicitud de Reserva de Mesa {{number}} - {{name}}',
                powered_by: 'Powered By {{name}}',
                overview: 'Nueva Solicitud de Reserva de Mesa',
                title: 'Nueva Reserva Para {{name}}',
                subtitle: 'Número de Reserva {{number}}',
                description_confirmed: 'La reserva ha sido automáticamente confirmada. Puedes cancelarla a través del administrador y se le notificará a tu cliente.',
                description_unconfirmed: 'Por favor confirma o cancela la reserva a través del administrador.',
                url_pre_text: 'Ver y actualizar en',
            },
            email_new_booking_customer: {
                subject: 'Solicitud de Reserva de Mesa',
                powered_by: 'Powered By {{name}}',
                overview: 'Nueva Solicitud de Reserva de Mesa',
                title: 'Gracias Por Tu Reserva',
                subtitle: 'Número de Reserva {{number}}',
                description: '<b>Vas a recibir otro correo electrónico cuando tu reserva haya sido confirmada o rechazada.</b><br>Por favor, contáctanos para cualquier cambio en tu reserva. Los detalles de tu reserva son los siguientes:',
                url_pre_text: 'Puedes comprobar el estado de tu reserva en tiempo real en el siguiente enlace',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Reserva de Mesa Confirmada',
                subject_unconfirmed: 'Reserva de Mesa Cancelada',
                powered_by: 'Powered By {{name}}',
                overview: 'Solicitud de Reserva de Mesa',
                title_confirmed: 'Reserva Confirmada',
                title_unconfirmed: 'Reserva Cancelada',
                subtitle: 'Número de Reserva {{number}}',
                description_confirmed: 'Esperamos verte pronto. Por favor, contacta con nosotros si quieres realizar cualquier cambio en tu reserva.',
                description_unconfirmed: 'Lamentamos informarte de que tu solicitud de reserva no ha sido aceptada. Sentimos la molestia. Por favor, ponte en contacto con nosotros para cualquier cuestión.',
                url_pre_text: 'Puedes ver el recibo de tu reserva en tiempo real en el siguiente enlace',
            },
            email_status_update_customer: {
                subject: 'Reserva #{{number}} – {{subjectLabel}}',
                body: 'Tu reserva #{{number}} en {{store}} ahora está {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Pedido #{{number}} – {{subjectLabel}}',
        header: 'Hora de preparación actualizada',
        title: 'Hora de preparación actualizada',
        order_number: 'Número de pedido: {{number}}',
        description: 'Tu pedido estará listo a las {{time}}.',
        order_time_updated_to: 'La hora de tu pedido ha sido actualizada.',
        powered_by: 'Energizado por {{name}}',
        button_text: 'Seguir Pedido',
        subject_label: 'Hora de preparación actualizada',
        subject_label_delivery: 'Hora de entrega actualizada',
        body_ready: 'Tu pedido estará listo a las {{time}}.',
        body_delivery: 'Tu pedido se entregará a las {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Tiempo de Entrega Estimado',
            est_driver_pickup_time: 'Est. Hora de Recogida del Conductor',
            est_delivery_time: 'Tiempo de Entrega Estimado',
            tab_details: 'Detalles',
            tab_dishes: 'Platos',
            details: {
                status: 'Estado',
                placed: 'Emitido',
                due: 'Esperado',
                due_asap: 'Ahora / Lo antes posible',
                last_updated: 'Última Actualización',
                total: 'Total',
                type: 'Tipo',
                table: 'Mesa',
                number_of_people: 'Número de Personas',
                payment_method: 'Método de Pago',
                payment_status: 'Estado de Pago',
                payment_currency: 'Moneda de Pago',
                notes: 'Notas',
                name: 'Nombre',
                email: 'Correo Electrónico',
                phone: 'Teléfono',
                distance: 'Distancia',
                driving_time: 'Tiempo de Conducción',
                delivery_zone: 'Zona',
                delivery_address: 'Dirección de Entrega',
                delivery_tracking: 'Seguimiento de Entregas',
                delivery_tracking_link: 'Enlace de Seguimiento en Tiempo Real',
                tookan_status: 'Tookan Status',
                tookan_status_failed_book: 'Error al reservar la entrega',
                tookan_status_failed_update: 'Error al actualizar la reserva',
                tookan_status_success: 'Reservado para entrega',
                store_address: 'Dirección de la Tienda',
            },
            dishes: {
                headings: {
                    quantity: 'Cantidad',
                    item: 'Artículo',
                    price: 'Precio',
                },
                notes: 'Notas',
                remove_ingredients: 'Eliminar Ingredientes',
            },
            status_update: {
                title: 'Pedido {{number}} Actualizado',
                body: 'El status de tu pedido ha sido actualizado a {{status}}',
            },
            wait_time_update: {
                title: 'Pedido {{number}} Actualizado',
                body: 'El vencimiento de su pedido ha sido actualizado',
            },
            delivery_update: {
                title: 'Pedido {{number}} Actualizado',
                body: 'Su pedido ha sido reservado para la entrega. Ver enlace de seguimiento en tiempo real',
            },
            email_new_order_restaurant: {
                subject: 'Nuevo Pedido ({{number}}) - {{name}}',
                powered_by: 'Powered By {{name}}',
                overview: 'Notificación de Nuevo Pedido',
                title: 'Nuevo Pedido Realizado en {{name}}',
                subtitle: 'Número de Pedido {{number}}',
                description: 'Ver el detalle y actualizaciones a través del administrador',
                button_text: 'Ver Pedido',
            },
            email_new_order_customer: {
                subject: 'Recibo del pedido ({{number}})',
                powered_by: 'Powered By {{name}}',
                overview: 'Notificación de Nuevo Pedido',
                title: 'Nuevo Pedido Realizado en {{name}}',
                subtitle: 'Número de Pedido {{number}}',
                description: 'Ver el detalle y actualizaciones a través del recibo online en tiempo real',
                button_text: 'Seguir Pedido',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inc. en precio',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Gastos de Envío',
            promo: 'Descuento: {{name}} ({{value, currency}} + {{percent}}% Descontado)',
            promo_percent: 'Descuento: {{name}} ({{percent}}%)',
            promo_fixed: 'Descuento: {{name}}',
            promo_none: 'Descuento: {{name}}',
            cart: 'Cesta',
            tip: 'Propina',
            total: 'Total',
        },
        status: {
            unconfirmed: 'Pendiente',
            awaiting_payment: 'Esperando el Pago',
            confirmed: 'Confirmado',
            ready: 'Listo',
            on_route: 'En ruta',
            complete: 'Completado',
            cancelled: 'Cancelado',
            seated: 'Sentado',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'No Disponible',
                },
            },
            dish: {
                no_stock: 'Agotado',
                not_available: 'No disponible',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'Código de confirmación de correo electrónico',
            register_confirmation_code_email: 'Su código de confirmación por correo electrónico es {{confirmation_code}} (Caduca en 24 horas)',
            register_confirmation_code_email_onbehalf: 'Su código de confirmación por correo electrónico es {{confirmation_code}} (Caduca en 24 horas). Esto es para la dirección de correo electrónico, {{email}}.',
        },
    },
};
//# sourceMappingURL=es.js.map